import { useAuthToken } from '@/hooks/useAuthToken';
import { reactQueryClient } from '@/utils/reactQueryClient';
import { scribeHttpV2 } from '@/utils/scribeHTTP';
import { getTempUserId } from '@/utils/tempUser';
import type { ChatListResponse } from '@heidi/session/contracts';
import { useQuery } from '@tanstack/react-query';

export const GET_CHATS = 'get_chats';

export const invalidateChats = () => {
  return reactQueryClient.invalidateQueries({ queryKey: [GET_CHATS] });
};

export function useQueryChats(page = 1, pageSize = 100) {
  const token = useAuthToken();
  const tempUserId = getTempUserId();

  return useQuery<ChatListResponse>({
    queryKey: [GET_CHATS, page, pageSize],
    // Only fetch when authenticated (token) or anonymous (tempUserId)
    // This prevents the query from firing before auth is initialized
    enabled: !!token || !!tempUserId,
    queryFn: async () => {
      const { data } = await scribeHttpV2.get<ChatListResponse>('/chat/chats', {
        params: { page, page_size: pageSize },
      });
      return data;
    },
  });
}
